define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi",
	"csi/action/DeleteController",
	"csi/xml"
], function(array,declare,csi,DeleteController,xml) {

	return declare(DeleteController, {
		calendarGetPendingRequest: function(node, cache, parentNode) {
			// summary: find calendar requests for given node and draw status
			var requests = cache.getParents(xml.nodeGetURL(node), "RequestCalendar");
			if (requests) {
				requests = array.filter(requests, function(cr) { return xml.nodeGetType(cr) == "CalendarRequest"; });
			}

			// Have to check that the request points to this node.
			if (parentNode && requests) {
				var	urlParent = xml.nodeGetAttributeValue(node, xml.ATTR_PARENT);
				requests = array.filter(requests, function(cr) { return xml.nodeGetAttributeValue(cr, "ParentNode") == urlParent; });
			}

			if (requests) {
				// sort by create time
				if (requests.length > 1) {
					requests = csi.sort(requests, function(cr) {
						return xml.nodeGetProperty(cr, xml.PROP_CREATE_TIME);
					});
				}

				if (requests.length && (xml.nodeGetAttributeValue(requests.last(), "RequestStatus") == "Pending")) {
					return requests.last();
				}
			}

			return null;
		},

		postProcess: function(bStatus) {
			var	node = this.m_cache.getNode(this.m_urlNode, true);
			var requestNode = null;

			if (xml.nodeGetType(node) == 'MasterCalendar') {
				requestNode = this.calendarGetPendingRequest(node, this.m_cache);
			} else {
				requestNode = this.calendarGetPendingRequest(node, this.m_cache, node);
			}

			if (requestNode) {
				this.widget.redrawNode(this.m_element);
			}

			this.inherited(arguments);
		}
	});
});